/*
 * @Author: Wangyiping
 * @Description: 希望是最后一次写这个功能
 * @Date: 2020-03-26 21:08:56
 * @LastEditTime: 2020-05-21 11:17:17
 */

/**
 * @description: 如果有app，直接打开schemeUrl对应的地址，否则跳去gp下载，安卓考虑到不同机型问题，直接用oneLink特性跳转
 * @param {string} schemeUrl scheme协议对应的跳转地址
 * @param {string} onelink gp下载地址
 * @return: undefined
 */

// 反复高速打点看用户到底出去了没
const checkOut = () =>
  new Promise((resolve, reject) => {
    try {
      let checkTimer: NodeJS.Timeout;
      let beatMax = 10; // 不能一直打点，打10次点，限时4s，检测用户出去过没有
      const showCheck = function () {
        if (document.hidden || !beatMax--) {
          clearTimeout(checkTimer);
          resolve((beatMax >= 0 && true) || false);
          return;
        }
        checkTimer = setTimeout(showCheck, 400);
      };
      showCheck();
    } catch (e) {
      reject(e);
    }
  });

/**
 * @description: openOrDownload
 * @param {string} schemeUrl scheme协议地址
 * @param {string} oneLink onlink
 * @param {function} callback
 * @return: undefined
 */
const openOrDownload = async (schemeUrl: string, oneLink: string, callback?: any) => {
  window.location.href = schemeUrl;
  const hasLeft = await checkOut();
  if (!hasLeft) {
    window.location.href = oneLink;
  }
  callback && callback(hasLeft);

  return;
};

export default openOrDownload;
